import { gql, useMutation } from '@apollo/client';

const SUBSCRIBE_TO_BUNDLE_AND_PROCESS = gql`
  mutation subscribeToBundleAndProcess(
    $input: SubscribeToBundleAndProcessInput!
  ) {
    subscribeToBundleAndProcess(input: $input) {
      bundleSlug
      bundleType
      autoRenew
      processDate
      price
    }
  }
`;

const useSubscribeToBundleAndProcess = () =>
  useMutation(SUBSCRIBE_TO_BUNDLE_AND_PROCESS);

export default useSubscribeToBundleAndProcess;
